import { render, staticRenderFns } from "./TaskLabelsInCard.vue?vue&type=template&id=df29332a&scoped=true"
import script from "./TaskLabelsInCard.vue?vue&type=script&lang=js"
export * from "./TaskLabelsInCard.vue?vue&type=script&lang=js"
import style0 from "./TaskLabelsInCard.vue?vue&type=style&index=0&id=df29332a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df29332a",
  null
  
)

export default component.exports